import React from "react"

const MapSlotSkeleton = () => {
  return (
    <div className="w-full h-full bg-gradient-to-br from-bg-secondary to-surface-soft relative flex flex-col items-center justify-center gap-3 animate-pulse">
      <svg className="absolute inset-0 w-full h-full opacity-10" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="grid-skeleton" width="40" height="40" patternUnits="userSpaceOnUse">
            <path
              d="M 40 0 L 0 0 0 40"
              fill="none"
              stroke="rgb(var(--app-base-strong))"
              strokeWidth="0.5"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid-skeleton)" />
      </svg>

      <div className="relative z-10 flex flex-col items-center gap-4 w-full px-8">
        <div className="w-14 h-14 rounded-full bg-app-content-faint/40" />

        <div className="w-32 h-3 bg-app-content-faint/40 rounded" />
        <div className="w-48 h-2 bg-app-content-faint/25 rounded" />

        <div className="w-full mt-4 flex flex-col gap-2">
          <div className="w-full h-2 bg-app-content-faint/40 rounded opacity-60" />
          <div className="w-4/5 h-2 bg-app-content-faint/40 rounded opacity-50" />
          <div className="w-3/5 h-2 bg-app-content-faint/40 rounded opacity-40" />
        </div>
      </div>
    </div>
  )
}

export default MapSlotSkeleton
